module.exports = __webpack_public_path__ + "app/images/amt24/favicon.amt24.png";